/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @file Global event messenger.
 *
 * @author Tomáš Burian (burian@cadwork.cz)
 */

import Model from "App/model";

export default
class Messenger {

    private static _applicationReady: boolean = false;
    private static _delayedDrawModels: Model[] = [];
    private static _buffer: any [] = [];

    public static setApplicationReady(aValue: boolean): void
    {
        Messenger._applicationReady = aValue;
        Messenger.processEvents();
    }

    public static addDelayedModelDraw(aModel: Model): void
    {
        Messenger._delayedDrawModels.push(aModel);
    }

    /***
     * Process event from teh scene graph only when the application is ready i.e. all the required listeners to the engine
     * events are registered in teh application
     */
    public static processEvents(): void
    {
        let i = 0;
        if (!Messenger._applicationReady) {
            return;
        }

        while (i < Messenger._buffer.length) {
            let s = Messenger._buffer[i].sender;
            let e = Messenger._buffer[i];

            s.dispatchEvent(e);
            i++;
        }
        Messenger._buffer = [];
    }

    public static release(): void
    {
        Messenger._buffer = [];
        Messenger._applicationReady = false;
    }

    // TODO: made a list of types i.e. messge to send
    public static fireCDWKEvent(aSender: HTMLElement, aType: string, aParams: any): void
    {
        let evt: any = document.createEvent("Event");
        evt.initEvent(aType, true, true);
        // @ts-ignore
        evt.params = aParams;
        // @ts-ignore
        evt.sender = aSender;

        Messenger._buffer.push(evt);
    }
}
